import React from 'react';
import './VideaLogoLarge.css';

const VideaLogoLarge = () => (
  <svg
    height="inherit"
    viewBox="0 0 300 230"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.2">
      <path
        d="M206.469 231.771C204.982 231.771 203.527 231.181 202.472 230.096L55.6818 80.4319C54.4188 79.1559 53.8593 77.3535 54.163 75.583C54.4668 73.8124 55.6018 72.3131 57.2005 71.5156L209.33 -3.19707C211.84 -4.42526 214.878 -3.62773 216.444 -1.3149L266.355 72.5843C267.362 74.0677 267.586 75.9498 266.963 77.6246L211.728 228.103C211.073 229.905 209.522 231.229 207.652 231.644C207.268 231.739 206.868 231.771 206.469 231.771ZM69.0786 78.1351L204.279 215.98L255.484 76.4762L209.906 8.97324L69.0786 78.1351Z"
        fill="white"
      />
      <path
        d="M92.5312 231.771C92.1475 231.771 91.7479 231.723 91.3482 231.644C89.4778 231.245 87.927 229.905 87.2716 228.103L32.0374 77.6406C31.4139 75.9658 31.6537 74.0836 32.6449 72.6002L82.5555 -1.29894C84.1222 -3.61178 87.1597 -4.42526 89.6696 -3.18111L241.799 71.5315C243.414 72.329 244.533 73.8284 244.837 75.5989C245.141 77.3694 244.581 79.1719 243.318 80.4479L96.5119 230.112C95.4728 231.181 94.018 231.771 92.5312 231.771ZM43.5319 76.4603L94.7374 215.964L229.937 78.1191L89.1101 8.97325L43.5319 76.4603Z"
        fill="white"
      />
    </g>
  </svg>
);

export default VideaLogoLarge;
